module.exports = __webpack_public_path__ + "media/img/use-ico-6-03996f7b00fa454eccde17172d774a0b.svg";